import { useMemo, useState } from "react";
import useAuthentication from "../../Modules/Authentication/Service/hooks/useAuthentication";

export default function AuthenticationMenu({  }) {

    const [showMenu, setShowMenu] = useState(false);
    const { authenticated, tokens, authenticationToken, logout, removeSpecialTokens, resetEverything } = useAuthentication();

    const hasPasskey = useMemo(() => {
        return (tokens || []).some(token => token.t == 'passkey');
    }, [tokens]);

    const has2FARemembered = useMemo(() => {
        return (tokens || []).some(token => token.t == 'totp-remember');
    }, [tokens]);

    const onRefresh = () => {
        location.reload();
    }   

    if(!showMenu) {
        return  <button className="fixed top-2 right-2 rounded-full  p-2 cursor-pointer bg-[#3A194A]" onClick={() => setShowMenu(true)}>
        <LoginMenuButton />
    </button>
    }

    return <div className="">
        <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50" onClick={() => setShowMenu(false)}>
            <div className="fixed top-2 right-2 bg-whiterounded-lg">
                <button className="rounded-full  p-2 cursor-pointer bg-[#3A194A]" onClick={() => setShowMenu(false)}><XMarkButton /></button>
            </div>
            <div className=" w-full h-full p-4 flex items-center justify-center">
                <div className="flex flex-col gap-1">
                    <button 
                        className="px-6 py-3 text-center bg-[#3A194A] text-white rounded-t-lg" 
                        onClick={() => onRefresh()}>Verversen</button>
                    { authenticationToken && <button 
                        className="px-6 py-3 text-center bg-[#3A194A] text-white " 
                        onClick={() => logout({ onlyRemoveToken: true })}>Uitloggen</button> || null}
                    { hasPasskey && <button 
                        className="px-6 py-3 text-center bg-[#3A194A] text-white" 
                        onClick={() => removeSpecialTokens({ type: 'passkey' })}>Passkey resetten</button> || null }
                    { has2FARemembered && <button 
                        className="px-6 py-3 text-center bg-[#3A194A] text-white" 
                        onClick={() => removeSpecialTokens({ type: 'totp-remember' })}>2FA herinnering resetten</button> || null }
                    <button 
                        className="px-6 py-3 text-center bg-[#3A194A] text-white rounded-b-lg" 
                        onClick={() => resetEverything()}>Applicatie resetten</button>
                </div>
            </div>
        </div>
    </div>
}

function LoginMenuButton(props) {
    return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-white" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z" />
    </svg>
}

function XMarkButton(props) {

    return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-white" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>

}